import { render, staticRenderFns } from "./model1Swiper.vue?vue&type=template&id=66ab917a&scoped=true"
import script from "./model1Swiper.vue?vue&type=script&lang=js"
export * from "./model1Swiper.vue?vue&type=script&lang=js"
import style0 from "./model1Swiper.vue?vue&type=style&index=0&id=66ab917a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ab917a",
  null
  
)

export default component.exports